/* Bachelor 99 — landing page interactions */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- stagger: children of [data-stagger] reveal one after another ---------- */
  function stagger() {
    document.querySelectorAll('.b99 [data-stagger]').forEach(function (box) {
      if (box.dataset.stg) return;
      box.dataset.stg = '1';
      var step = parseFloat(box.getAttribute('data-stagger')) || 0.08;
      var base = parseFloat(box.getAttribute('data-stagger-delay')) || 0;
      box.classList.remove('rv', 'rvs');
      Array.prototype.forEach.call(box.children, function (child, i) {
        if (!child.classList.contains('rv') && !child.classList.contains('rvs')) {
          child.classList.add('rv');
        }
        child.style.setProperty('--d', (base + i * step).toFixed(2) + 's');
      });
    });
  }

  /* ---------- scroll reveal ---------- */
  function reveal() {
    var els = document.querySelectorAll('.b99 .rv:not(.in), .b99 .rvs:not(.in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- ripple on every button ---------- */
  function ripple(e) {
    var btn = e.currentTarget;
    if (reduce) return;
    var r = btn.getBoundingClientRect();
    var size = Math.max(r.width, r.height);
    var s = document.createElement('span');
    s.className = 'rp';
    s.style.width = s.style.height = size + 'px';
    s.style.left = ((e.clientX || r.left + r.width / 2) - r.left - size / 2) + 'px';
    s.style.top = ((e.clientY || r.top + r.height / 2) - r.top - size / 2) + 'px';
    btn.appendChild(s);
    setTimeout(function () { s.remove(); }, 620);
  }
  function bindRipples() {
    document.querySelectorAll('.b99 .btn').forEach(function (b) {
      if (b.dataset.rp) return;
      b.dataset.rp = '1';
      b.addEventListener('click', ripple);
    });
  }

  /* ---------- press feedback on any clickable thing that is not a .btn ---------- */
  function press() {
    document.querySelectorAll('.b99 .card, .b99 .step, .b99 .stat, .b99 .pill, .b99 .faq summary').forEach(function (el) {
      if (el.dataset.pr) return;
      el.dataset.pr = '1';
      el.addEventListener('pointerdown', function () {
        if (reduce) return;
        el.style.transition = 'transform .1s var(--e)';
        el.style.transform = 'scale(.985)';
      });
      ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) {
        el.addEventListener(ev, function () { el.style.transition = ''; el.style.transform = ''; });
      });
    });
  }

  /* ---------- count-up stats ---------- */
  function counters() {
    var nums = document.querySelectorAll('.b99 [data-count]:not([data-done])');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-count'); n.dataset.done = '1'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        el.dataset.done = '1';
        var target = parseInt(el.getAttribute('data-count'), 10) || 0;
        var suffix = el.getAttribute('data-suffix') || '';
        var dur = 1100, t0 = null;
        function tick(ts) {
          if (!t0) t0 = ts;
          var p = Math.min((ts - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- buy button: add to cart, then straight to checkout ---------- */
  function buy() {
    document.querySelectorAll('.b99 [data-buy]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;               /* no fetch: let the form post normally */
        e.preventDefault();
        var btn = form.querySelector('.btn');
        var idField = form.querySelector('[name="id"]');
        if (!idField) { form.submit(); return; }
        var id = idField.value;
        if (btn) {
          if (btn.classList.contains('loading')) return;   /* double-tap guard */
          btn.classList.add('loading');
          var sp = document.createElement('span');
          sp.className = 'spin';
          btn.appendChild(sp);
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { form.submit(); });   /* fall back to a normal post */
      });
    });
  }

  /* ---------- smooth in-page scrolling ---------- */
  function anchors() {
    document.querySelectorAll('.b99 a[href^="#"]').forEach(function (a) {
      if (a.dataset.an) return;
      a.dataset.an = '1';
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href');
        if (!href || href === '#') return;
        var t = document.querySelector(href);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ---------- one FAQ open at a time ---------- */
  function faq() {
    var all = document.querySelectorAll('.b99 .faq details');
    all.forEach(function (d) {
      if (d.dataset.fq) return;
      d.dataset.fq = '1';
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        document.querySelectorAll('.b99 .faq details').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      });
    });
  }

  function init() {
    stagger();
    reveal();
    bindRipples();
    press();
    counters();
    buy();
    anchors();
    faq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();